"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

const links = [
  { href: "/", label: "Trening" },
  { href: "/coach", label: "Coach" },
] as const;

export function AppNav() {
  const pathname = usePathname();

  return (
    <nav
      className="w-full max-w-5xl flex items-center gap-1 rounded-xl border border-slate-800 bg-slate-900/80 p-1"
      aria-label="Glavna navigacija"
    >
      {links.map(({ href, label }) => {
        const active =
          href === "/"
            ? pathname === "/" || pathname === ""
            : pathname.startsWith(href);
        return (
          <Link
            key={href}
            href={href}
            className={`flex-1 rounded-lg px-4 py-2 text-center text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 ${
              active
                ? "bg-blue-600 text-white"
                : "text-slate-400 hover:text-slate-200 hover:bg-slate-800"
            }`}
          >
            {label}
          </Link>
        );
      })}
    </nav>
  );
}
